/**
 * Configurações de ambiente da aplicação
 * 
 * Este arquivo centraliza todas as variáveis de ambiente da aplicação,
 * facilitando o acesso e garantindo tipagem consistente.
 * 
 * As variáveis devem ser definidas no arquivo .env com o prefixo REACT_APP_
 */
export const env = {
  /** URL base da API */
  API_URL: process.env.REACT_APP_API_URL,
  
  /** URL do serviço Turnstile (Cloudflare) */
  TURNSTILE_URL: process.env.REACT_APP_TURNSTILE_URL,
  
  /** Chave pública do site para o Turnstile */
  TURNSTILE_SITE_KEY: process.env.REACT_APP_TURNSTILE_SITE_KEY,
  
  /** Menu padrão da aplicação */
  MENU_DEFAULT: process.env.REACT_APP_MENU_DEFAULT,

  /** ID da campanha atual */
  CAMPAIGN_ID: process.env.REACT_APP_CAMPAIGN_ID,

  /**
   * Ativa o tapume de "Em manutenção" (string `'true'`).
   * Pode ser ignorado pontualmente acessando a aplicação com `?debug=1`.
   */
  MAINTENANCE_MODE: process.env.REACT_APP_MAINTENANCE_MODE
} as const;
